(function () {
  if (window.OnegripCustomStrap) return;

  var allowed = /^[A-ZÅÄÖ0-9]{1,8}$/;
  var startMarker = '[Anpassade straps]';
  var endMarker = '[/Anpassade straps]';
  var noteJob = Promise.resolve();

  function route(path) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + path;
  }

  function widgetFor(form) {
    return form && form.querySelector('[data-og-custom-strap]');
  }

  function updateWidget(widget) {
    var checked = widget.querySelector('[data-og-strap-toggle]').checked;
    var fields = widget.querySelector('[data-og-strap-fields]');
    var input = widget.querySelector('[data-og-strap-text]');
    var checkout = widget.closest('product-form-component')?.querySelector('.accelerated-checkout-block');
    fields.hidden = !checked;
    input.required = checked;
    if (checkout) checkout.hidden = checked;
    if (checked) input.focus();
    widget.dispatchEvent(new CustomEvent('onegrip:strap-change', { bubbles: true }));
  }

  function normalizeInput(input) {
    input.value = input.value.replace(/[^A-Za-zÅÄÖåäö0-9]/g, '').slice(0, 8).toLocaleUpperCase('sv-SE');
    input.setCustomValidity('');
    input.removeAttribute('aria-invalid');
    var widget = input.closest('[data-og-custom-strap]');
    widget.querySelector('[data-og-strap-count]').textContent = input.value.length + '/8';
    widget.querySelector('[data-og-strap-error]').hidden = true;
  }

  function showError(input) {
    var message = input.closest('[data-og-custom-strap]').dataset.errorMessage;
    input.setCustomValidity(message);
    input.setAttribute('aria-invalid', 'true');
    var error = input.closest('[data-og-custom-strap]').querySelector('[data-og-strap-error]');
    error.textContent = message;
    error.hidden = false;
  }

  function getSelection(form) {
    var widget = widgetFor(form);
    if (!widget || !widget.querySelector('[data-og-strap-toggle]').checked) return null;
    var input = widget.querySelector('[data-og-strap-text]');
    normalizeInput(input);
    if (!allowed.test(input.value)) {
      showError(input);
      input.reportValidity();
      return { error: true };
    }
    return {
      id: Number(widget.dataset.strapVariantId),
      text: input.value,
      price: Number(widget.dataset.strapPrice),
      gloveTitle: widget.dataset.gloveTitle || ''
    };
  }

  function makePair(gloveId, quantity, selection) {
    var pairId = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 9);
    return [
      {
        id: Number(gloveId),
        quantity: Number(quantity) || 1,
        properties: { _strap_pair: pairId }
      },
      {
        id: selection.id,
        quantity: Number(quantity) || 1,
        properties: {
          'Text på strap': selection.text,
          'Till handskar': selection.gloveTitle,
          _strap_pair: pairId,
          _onegrip_custom_strap: '1'
        }
      }
    ];
  }

  function desiredNote(cart) {
    var current = (cart.note || '').replace(/\s*\[Anpassade straps\][\s\S]*?\[\/Anpassade straps\]/g, '').trim();
    var lines = (cart.items || []).filter(function (item) {
      return item.properties && item.properties._onegrip_custom_strap === '1';
    }).map(function (item) {
      var text = item.properties['Text på strap'];
      var glove = item.properties['Till handskar'];
      return text + (glove ? ' – ' + glove : '') + (item.quantity > 1 ? ' (x' + item.quantity + ')' : '');
    });
    return lines.length ? [current, startMarker + '\n' + lines.join('\n') + '\n' + endMarker].filter(Boolean).join('\n\n') : current;
  }

  function syncCartNote(cart) {
    noteJob = noteJob.catch(function () {}).then(async function () {
      var latest = cart || await fetch(route('cart.js')).then(function (r) { return r.json(); });
      var note = desiredNote(latest);
      if (note === (latest.note || '')) return latest;
      var response = await fetch(route('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note })
      });
      if (!response.ok) throw new Error('Could not save custom strap cart note');
      return response.json();
    });
    return noteJob;
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-og-strap-toggle]')) updateWidget(event.target.closest('[data-og-custom-strap]'));
  });
  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-og-strap-text]')) normalizeInput(event.target);
  });
  document.addEventListener('invalid', function (event) {
    if (event.target.matches('[data-og-strap-text]')) showError(event.target);
  }, true);
  document.addEventListener('cart:update', function () {
    syncCartNote().catch(function (error) { console.error('[onegrip] strap note sync failed', error); });
  });

  window.OnegripCustomStrap = { getSelection: getSelection, makePair: makePair, syncCartNote: syncCartNote };
})();
